import React, { useState } from "react";
import moment from "moment";

import { DashboardCard2 } from "@/ui2/molecules/DashboardCard2";

import AddendumDisplay from "./AddendumDisplay";
import AddendumForm from "./AddendumForm";
import AddendumLink from "./AddendumLink";
import { api } from "../../../../APIRequests";

import "./styles.scss";

export function NoteAddendum({
  noteId,
  patientId,
  addendum,
  signature,
  credentials,
  timestamp,
  onSubmit,
  textTestId,
}) {
  const [isForm, setIsForm] = useState(false);

  const submitAddendum = async (addendum) => {
    const urlParams = { patientId };
    const data = {
      note_id: noteId,
      timestamp: moment().unix(),
      addendum,
      signature,
      credentials,
    };
    await api.shared.create_note_addendum({ urlParams, data });
    onSubmit(data);
  };

  return (
    <DashboardCard2 className="NoteAddendum tw:w-full" classNameChildren="tw:flex tw:w-full">
      {!addendum && !isForm && <AddendumLink onClick={() => setIsForm(true)} />}
      {!addendum && isForm && (
        <AddendumForm
          onSubmit={async (formData) => {
            await submitAddendum(formData.addendum);
            setIsForm(false);
          }}
          onCancel={() => setIsForm(false)}
        />
      )}

      {addendum && !isForm && (
        <AddendumDisplay
          addendum={addendum}
          signature={signature}
          credentials={credentials}
          timestamp={timestamp}
          textTestId={textTestId}
        />
      )}
    </DashboardCard2>
  );
}
